import { render, staticRenderFns } from "./staff-checkbox-group.vue?vue&type=template&id=610cd6ff&scoped=true"
import script from "./staff-checkbox-group.vue?vue&type=script&lang=js"
export * from "./staff-checkbox-group.vue?vue&type=script&lang=js"
import style0 from "./staff-checkbox-group.vue?vue&type=style&index=0&id=610cd6ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610cd6ff",
  null
  
)

export default component.exports